// Google Analytics Helper Functions

export const GA_TRACKING_ID = 'G-QX6NE881TS';

// Track page views
export const pageview = (url) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', GA_TRACKING_ID, {
      page_path: url,
    });
  }
};

// Track events
export const event = ({ action, category, label, value }) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

// Predefined events for GENSOL
export const trackWhatsAppClick = () => {
  event({
    action: 'whatsapp_click',
    category: 'Contact',
    label: 'WhatsApp Button Clicked'
  });
};

export const trackPhoneClick = () => {
  event({
    action: 'phone_click',
    category: 'Contact',
    label: 'Phone Number Clicked'
  });
};

export const trackEmailClick = () => {
  event({
    action: 'email_click',
    category: 'Contact',
    label: 'Email Clicked'
  });
};

export const trackFormSubmit = (equipmentType) => {
  event({
    action: 'form_submit',
    category: 'Lead',
    label: `Contact Form - ${equipmentType || 'General'}`
  });
};

export const trackQuoteClick = (equipment) => {
  event({
    action: 'quote_click',
    category: 'Lead',
    label: `Quote Request - ${equipment}`
  });
};

export const trackServiceClick = (service) => {
  event({
    action: 'service_click',
    category: 'Engagement',
    label: `Service Viewed - ${service}`
  });
};
